import React  from 'react';
import { VARIANTS_PER_PORTAL } from 'constants/env';

export function HeaderPromo() {

    const showCredit = VARIANTS_PER_PORTAL.menuMobile.find(pos => pos.iconClass === 'icoCredito' )

    return (
        <nav className="promoHeader">
            <ul className="ulMenuMarcas">
                <li className="menuMesa"><a href="/Mesa-de-Regalos?utm_source=direct&utm_medium=menu-superior-home-sears-com&utm_campaign=mesa_de_regalos" target="_blank" rel="noopener noreferrer">Mesa de Regalos</a></li>
                {showCredit &&
                    <li><a href={`${showCredit.url}`} >Crédito</a></li>
                }
            </ul>
        </nav>
    )
}
